<template>
  <div id="subscript">
    <div class="ipub-h1 mar-b-20 flex relative">Subscribe

    </div>
    <div class="mar-b-20">
      <ipub-row :gutter="20">
        <ipub-col :span="3">
          <div class="flex">
            <span class="line-h-40">Sources</span>
            <ipub-select v-model="nameList"
                         placeholder="Select Sources"
                         mode="multiple"
                         class="mar-l-20"
                         @change="changeSource">
              <ipub-select-option v-for="item in journalList"
                                  :key="'editorList'+item.id"
                                  :value="item.name">
                <span class="link-color"
                      v-if="item.name==='imr'">{{item.fullName}}</span>
                <span v-else>{{item.name}}</span>
              </ipub-select-option>
            </ipub-select>
          </div>
        </ipub-col>
        <ipub-col :span="9">
          <div class="flex relative">
            <span class="line-h-40"
                  style="width:120px">Subscribe Date</span>
            <ipub-date-range-picker class="mar-l-12"
                                    style="width:500px"
                                    :placeholder="['From','To']"
                                    @change="handleDateChange"
                                    v-model="date" />
            <ipub-button class="search-group-button"
                         @click="handleClear"
                         style="width: 40px;padding: 0;font-size: 28px;margin-left:16px"
                         type="primary"
                         icon="iconClear" />
            <div class="ipub-p1 mar-l-16"
                 v-show="user.codeList&&user.codeList.includes('EDITOR_TASK.SUBSCRIPTION.EXPORT')">
              <ipub-button type="primary"
                           @click="exp">
                Export
              </ipub-button>
            </div>
          </div>

        </ipub-col>

      </ipub-row>
    </div>
    <div>
      <ipub-table :columns="columns"
                  emptyText="There is no  author subscription."
                  :pagination="pagination"
                  :dataSource="dataSource"
                  @order="onOrderChanage">
        <template v-slot:actions="{record}">
          <ipub-tooltip v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.SUBSCRIPTION.DELETE')">
            <div slot="title">Delete</div>
            <ipub-icon type="iconDelete"
                       @click="del(record)" />
          </ipub-tooltip>
          <template v-else>
            <ipub-icon type="iconDelete"
                       class="line-color" />
          </template>
        </template>
      </ipub-table>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
